import { render } from "./PFTable.vue?vue&type=template&id=2dd1f2d2"
import script from "./PFTable.vue?vue&type=script&lang=js"
export * from "./PFTable.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__